import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import SectionContact from '../Components/SectionContact';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import logo from '../Medias/Logos/logo.png';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { TbMapPin, TbPhoneCall, TbMail } from "react-icons/tb";

const Contact = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Contact us' detail='Get in touch with our legal team for trusted and professional advice.' bg={Bg} />
      <section className='pt-5'>
        <Container className='pt-5 text-center'>
          <Row>
            <Col>
              {/* <img src={logo} style={{maxWidth: '140px'}} /> */}
              <h3 className='mt-3 mb-5'>PT & Associates</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card style={{ borderColor: 'var(--color-primary)' }}>
                <Card.Body>
                  <div>
                    <TbMail size={32} />
                  </div>
                  <div>
                    <h6 className='font-header fw-bold mt-2 mb-3 text-uppercase'>Email Us</h6>
                    <a href="mailto:info@pt-assoc.com" className='mb-0 tx-color-secondary text-decoration-none'>info@pt-assoc.com</a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card style={{ borderColor: 'var(--color-primary)' }}>
                <Card.Body>
                  <div>
                    <TbMapPin size={32} />
                  </div>
                  <div>
                    <h6 className='font-header fw-bold mt-2 mb-3 text-uppercase'>Address</h6>
                    <p className='mb-0'>No. 209 Soi Muban, Mittraphap 2
                      Nong Bon, Prawet, Bangkok, Thailand 10250</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card style={{ borderColor: 'var(--color-primary)' }}>
                <Card.Body>
                  <div>
                    <TbPhoneCall size={32} />
                  </div>
                  <div>
                    <h6 className='font-header fw-bold mt-2 mb-3 text-uppercase'>Call Us</h6>
                    <a href="tel:063-421-3018" className='mb-0 tx-color-secondary text-decoration-none'>063-421-3018</a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <SectionContact contents={contents} />
    </>
  )
}

Contact.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Contact